import React from 'react';
import { Box, Typography } from '@mui/material';
import PATHS from 'lib/navigation/paths';
import Typography500 from 'views/common/components/UI/Typography500';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';

import StyledBox, {
  StyledERClubBadge,
} from 'views/rebranded-module/location-module/LocationsViewV2/components/DistrictLocations/DistrictLocations.styles';
import { Typography700 } from 'views/rebranded-module/common/components';

const DistrictLocations = (props) => {
  const {
    district, membershipEnabled, defaultVehicleType, content,
  } = props;

  return (
    <StyledBox>
      <Box>
        <NavigatorLink
          className="DLocationLink"
          href={PATHS.geoSlug([defaultVehicleType.slug, district.region.slug])}>
          <Typography700
            variant="h6"
            component="p"
            className="DLLocationItem DLLocationItemTitle">
            {district.region.name}
          </Typography700>
        </NavigatorLink>
      </Box>
      {district.markets?.map((market) => (
        <Box mb={3}>
          {market.name && (
            <Box>
              <NavigatorLink
                className="DLocationLink"
                href={
                  market.geography_slug
                    ? PATHS.geoSlug([
                      defaultVehicleType.slug,
                      market.geography_slug,
                    ])
                    : PATHS.locationSlug(market.slug)
                }
                key={market.id}>
                <Typography500
                  variant="body1"
                  component="p"
                  className="DLLocationItem"
                  ml={0.8}>
                  {market.name}
                </Typography500>
              </NavigatorLink>
            </Box>
          )}
          {market.locations.map((location) => (
            <Box>
              <NavigatorLink
                className="DLocationLink"
                href={PATHS.locationSlug(location.slug)}
                key={location.id}
                data-testid={`locations-directory-link-${encodeURIComponent(
                  location.name,
                )}`}>
                <Typography
                  variant="body1"
                  className="DLLocationItem DLLocationLink"
                  component="p"
                  ml={1.2}>
                  {location.name}
                  {' '}
                  {location.membership && membershipEnabled && (
                    <StyledERClubBadge content={content} />
                  )}
                </Typography>
              </NavigatorLink>
            </Box>
          ))}
        </Box>
      ))}
      {district.locations?.map((location) => (
        <Box>
          <NavigatorLink
            className="DLocationLink"
            href={PATHS.locationSlug(location.slug)}
            key={location.id}
            data-testid={`locations-directory-link-${encodeURIComponent(
              location.name,
            )}`}>
            <Typography
              variant="body1"
              className="DLLocationItem DLLocationLink"
              component="p"
              ml={1.25}>
              {location.name}
              {' '}
              {location.membership && membershipEnabled && (
                <StyledERClubBadge content={content} />
              )}
            </Typography>
          </NavigatorLink>
        </Box>
      ))}
    </StyledBox>
  );
};

export { DistrictLocations };
